import axios from 'axios';

import config from '@/config';
import i18n from '@/i18n';

export class dimorderApi {
  constructor(url) {
    this.axios = axios.create({
      baseURL: url || config.baseUrl,
    });

    this.axios.interceptors.request.use(config => {
      const locale = i18n.language;
      if (locale) {
        config.headers['Accept-Language'] = locale;
      }
      return config;
    });
  }

  async getOrderDetail(id) {
    const response = await this.axios.get(`/g/order/${id}`);

    return response.data;
  }

  async getMerchantDetail(id) {
    const response = await this.axios.get(`/g/merchant/${id}`);

    return response.data;
  }
}

export default new dimorderApi();
